var Tile = function(full, color, gridPos, validGrid){
  this.full = full;
  this.color = color;
  this.gridPos = gridPos || false;
  this.validGrid = validGrid || false;
};

module.exports = Tile;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/tile.js
 ** module id = 4
 ** module chunks = 0
 **/